<template>
  <div class="people-list-referrals">
    <v-row no-gutters>
      <v-col cols="12">
        <div class="extra-margin">
          <div v-for="(person, index) in peoplePool" :key="index">
            <div class="list-item">
              <v-btn
                :ripple="false"
                block
                color="white"
                class="list-item-btn"
                @click.stop.prevent
              >
                <div class="list-item-content">
                  <div class="list-item-content-left">
                    <v-img
                      v-if="!person.claimed"
                      :src="
                        require(`@/assets/${whitelabel.images.referrals.emailSent}`)
                      "
                      class="referral-image"
                      aspect-ratio="1"
                      alt="Online will creator"
                      title="Online will creator"
                    />

                    <v-img
                      v-if="person.claimed"
                      :src="
                        require(`@/assets/${whitelabel.images.referrals.claimed}`)
                      "
                      class="referral-image"
                      aspect-ratio="1"
                      alt="Online will creator"
                      title="Online will creator"
                    />
                    <div>
                      <p class="list-item-container">
                        <span class="list-item-name">{{
                          person.fullName
                        }}</span>
                        <span
                          v-show="person.kinship"
                          class="list-item-separator"
                          >-</span
                        >
                        <span class="list-item-more-info">{{
                          formatPersonKinship(person.kinship)
                        }}</span>
                      </p>

                      <NoEmailAssigned v-if="!person.email" />
                    </div>
                  </div>
                  <GradientButton
                    v-if="!person.claimed"
                    :title="'Email'"
                    :small="true"
                    :fill="false"
                    :loading="person.sending"
                    :actionCompleted="person.sent"
                    :disabled="person.sent"
                    @gradientButtonClicked="resendEmail(person)"
                  />
                </div>
              </v-btn>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { formatKinship } from '../../constants/js/people.js';
  import { RESEND_TESTATOR_REFERRAL_EMAIL } from '../../constants/graphql/referrals';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'ReferralsList',
    props: {
      testator: { type: Object, required: true },
      people: { type: Array, required: true },
    },
    data(props) {
      return {
        peoplePool: props.people.map(person => {
          return {
            ...person,
            sending: false,
            sent: this.sentRecentReferral(person),
            claimed: this.claimedRecentReferral(person),
          };
        }),
      };
    },
    methods: {
      claimedRecentReferral(person) {
        const referrals = this.testator.user.referrals;
        const personIds = referrals
          .map(obj => obj.personId)
          .filter(id => id != null);
        if (personIds.includes(person.id)) {
          return true;
        } else {
          return false;
        }
      },
      sentRecentReferral(person) {
        if (!person.referralInviteSentTime) {
          return false;
        }

        const now = new Date();
        const receivedTime = new Date(person.referralInviteSentTime);

        const differenceInMinutes = (now - receivedTime) / (1000 * 60);
        return differenceInMinutes < 3;
      },
      formatPersonKinship(kinship) {
        return formatKinship(kinship, this.testator);
      },
      resendEmail(person) {
        person.sending = true;
        const personId = parseInt(person.id);

        this.$apollo
          .mutate({
            mutation: RESEND_TESTATOR_REFERRAL_EMAIL,
            variables: {
              userId: parseInt(this.userId),
              personId: personId,
            },
            update: (cache, { data: { resendTestatorReferralEmail } }) => {
              this.updateCacheAfterReferralsSent(
                cache,
                resendTestatorReferralEmail
              );
            },
          })
          .then(_response => {
            person.sending = false;
            person.referralInviteSentTime =
              _response.data.resendTestatorReferralEmail.referralInviteSentTime;
          })
          .catch(error => {
            person.sending = false;
            throw error;
          });
      },
      updateCacheAfterReferralsSent(cache, person) {
        const query = {
          query: TESTATOR_QUERY,
          variables: { id: this.testatorId },
        };
        const data = cache.readQuery(query);

        const personIndex = data.testator.people.findIndex(
          p => p.id === person.id
        );

        if (personIndex !== -1) {
          data.testator.people[personIndex] = person;
        }

        cache.writeQuery({ ...query, data: data });
      },
    },
    watch: {
      people(newValue) {
        this.peoplePool = newValue.map(person => {
          return {
            ...person,
            sending: false,
            sent: this.sentRecentReferral(person),
            claimed: this.claimedRecentReferral(person),
          };
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .extra-margin {
    margin-bottom: 25px;
  }

  .people-list-referrals {
    .list-item-container {
      margin: 0;
      display: inline-block;
      white-space: break-spaces;
    }

    .list-item-btn {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .list-item-content {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .list-item-content-left {
        display: flex;
        align-items: center;
        gap: 14px;
        p {
          margin: 0;
          font-size: 14px;
          font-weight: 500;
          line-height: 22px;
          text-align: left;
          color: #8c8c8c;
        }
      }
    }

    .referral-image {
      max-width: 24px;
      max-height: 24px;
    }
  }
</style>
